import { FC } from "react";
import { CircularProgress } from "@mui/material";
import muiIcons from "../icons/mui-icons";

interface Props {
  size?: number;
  loadButton: boolean;
}
const ButtonLoader: FC<Props> = ({ size, loadButton }) => {
  const { CircleIcon } = muiIcons;
  return (
    <>
      {loadButton ? (
        <CircularProgress
          sx={{ mr: "5px" }}
          size={size || 20}
          color="inherit"
        />
      ) : (
        <CircleIcon
          sx={{ mr: "5px", color: "inherit", fontSize: size || 20 }}
        />
      )}
    </>
  );
};

export default ButtonLoader;
